/// <amd-module name="VSS/Features/Charts/Internal/AxisTickPositioner" />

/** Provides ability to specify points for tick presentation.
 If neccessary, this class can be made configurable for enabling customization of options, such as min-max sample size.*/
export class AxisTickPositioner {
    private static _IdealNumSteps: number = 7; // We could generalize this to operate on basis of the length of the axis

    public getPositioner(): () => number[] {
        // We need highcharts to give us some context, which gets called as "this".
        // As a consequence, we can't use a lambda, and hold onto this.
        let that: AxisTickPositioner = this;

        let handler = function() {
            return that.positionTicks(this);
        };
        return handler;
    }

    public positionTicks(tickContext: PositionerContext): number[] {
        let positions = [],
            minTick = Math.floor(tickContext.dataMin),
            increment = Math.ceil((tickContext.dataMax - tickContext.dataMin) / AxisTickPositioner._IdealNumSteps);

        if (tickContext.dataMax !== null && tickContext.dataMin !== null && increment !== 0) {
            for (let tickPoint = minTick; tickPoint <= tickContext.dataMax; tickPoint += increment) {
                positions.push(tickPoint);
            }
        }
        return positions;
    }
}

export interface PositionerContext {
    /** The minimal known array index or point, as reported by Highcharts*/
    dataMin: number;

    /** The maximal known array index or point, as reported by Highcharts*/
    dataMax: number;

    /** The space allocated to this axis. Not currently used, but likely if we want conditional allocation by chart size.*/
    len?: number;
}
